$(function() {
    const readMore = $('.readMoreLink');

    readMore.each(function() {
        const thisItem = $(this);
        const thisButton = thisItem.find('.readMoreButton');
        const thisContent = thisItem.closest('.usercontent');

        thisButton.click(function() {
            console.log('button clicked');
            if (thisItem.hasClass('__active')) {
                thisItem.removeClass('__active');
                thisItem.children('button').removeClass('__active');
                thisContent.find('.readMore').slideUp(300);
            } else {
                thisItem.addClass('__active');
                thisItem.children('.readMoreButton').addClass('__active');
                thisContent.find('.readMore').slideDown(300);
            }
        });
    });
});
